import { useEffect } from 'react';
import { useCookieConsent } from '@monovo/onetrust';
import { loadGoogleTagManagerScript } from './loadGoogleTagManager';

export const useLoadGoogleTagManager = () => {
  const cookieConsents = useCookieConsent();

  useEffect(() => {
    // We wait for necessary consent category here only to ensure that tag manager
    // loads after the OneTrust script.
    // It also uses the consent categories to define what scripts to load.
    if (cookieConsents?.necessary) {
      loadGoogleTagManagerScript();
    }
  }, [cookieConsents?.necessary]);
};
